import { createApi } from '@reduxjs/toolkit/query/react'

import { getCustomFetch } from '@/shared/api/custom-fetch-base'

export const uploadApi = createApi({
  reducerPath: 'uploadApi',
  baseQuery: getCustomFetch(),
  tagTypes: ['template', 'task'],
  endpoints: build => ({
    upload: build.mutation({
      query: file => ({
        url: `/excel/upload`,
        method: 'POST',
        body: file,
      }),
    }),

    getTemplateList: build.query<string[], null>({
      query: () => ({
        url: '/excel/templates',
        method: 'GET',
      }),
      providesTags: ['template'],
    }),

    downloadTemplateFile: build.mutation<Blob, string>({
      query: fileName => ({
        url: `/excel/templates/${fileName}`,
        method: 'POST',
      }),
    }),
  }),
})

export const {
  useUploadMutation,
  useGetTemplateListQuery,
  useDownloadTemplateFileMutation,
} = uploadApi
